import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {BonusBunniesSoundConfig} from "../BonusBunniesSoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesParsedInitData} from "../server/data/BonusBunniesParsedInitData";
import {BonusBunniesParsedGameData} from "../server/data/BonusBunniesParsedGameData";

/**
 * Created by Jerker Nord on 2020-04-22.
 */

export class BonusBunniesSpinSoundsController {

    private _previousSound:number = -1;
    private _newSound:number = -1;
    private _bonusSpinsLeft:number;

    constructor() {
        EventHandler.addEventListener(this, SpinEvent.START, () => this.onSpinStart());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.parseFeatureGameData(event.params[0]));
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        this._bonusSpinsLeft = data.bonusSpinsRemaining;
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._bonusSpinsLeft = data.bonusSpinsRemaining;
    }

    private onSpinStart():void {
        while(this._newSound == this._previousSound) {
            this._newSound = MathHelper.randomIntInRange(0, (BonusBunniesSoundConfig.instance.SPIN_BUTTON_SOUNDS.length - 1));
        }
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.SPIN_BUTTON_SOUNDS[this._newSound]);
        this._previousSound = this._newSound;
    }
}